import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ui from '@nuxt/ui/vue-plugin'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'

import App from './App.vue'
import router from './router'
import AppComponent from './views/base/AppComponent.vue'

const app = createApp(App)

app.component('AppComponent', AppComponent)

app.use(createPinia())
app.use(router)
app.use(ui)
app.use(VCalendar, {})

app.mount('#app')
